import React from 'react'
import Index from '../../../../Index'
import PagesIndex from '../../../../PagesIndex'

export default function SellerMyAccountContent() {

      // VerifyAccountModal
      const [openSellerVerifyAccountModal, setOpenSellerVerifyAccountModal] = React.useState(false);
      const handleOpenSellerVerifyAccountModal = () => setOpenSellerVerifyAccountModal(true);
      const handleCloseSellerVerifyAccountModal = () => setOpenSellerVerifyAccountModal(false);
      return (
            <>
                  <Index.Box className="my-acc-content-section">
                        <Index.Box className="my-acc-content-row">
                              <Index.Box className="my-acc-content-main">
                                    <Index.Box className="my-acc-content-para"  component="p" variant="p" >Currently, you have no business details. <br/> Please verify
                                          your account !</Index.Box>
                                    <Index.Box className="my-verify-btn-main">
                                          <PagesIndex.OrangeFillButton btnLabel="Verify Account" className="orange-fill-btn veryfy-acc-btn" onClick={handleOpenSellerVerifyAccountModal} />
                                    </Index.Box>
                              </Index.Box>
                        </Index.Box>
                  </Index.Box>

                  <PagesIndex.SellerVerifyAccountModal openSellerVerifyAccountModal={openSellerVerifyAccountModal} handleCloseSellerVerifyAccountModal={handleCloseSellerVerifyAccountModal} />
            </>
      )
}
